export const SEAT_RADIUS = 2;
export const SEAT_SIZE = SEAT_RADIUS * 2;
export const VIEWPORT_PART_TO_DISPLAY = 0.8;
export const STAND_SCALE = 1.5;

export const SIDE_BAR = {
  width: {
    desktop: {
      min: '320px',
      max: '486px',
      default: '38%',
    },
  },
};

export const LANDING_SIDE_BAR = {
  width: {
    desktop: {
      min: '320px',
      max: '486px',
      default: '35%',
    },
  },
};

export const MOBILE_ANNOUNCEMENT_BAR_PART_FROM_VIEWPORT = 0.5;

export const SIDE_BAR_HEADER_HEIGHT = 83.1875;
